import { Translator } from '@/types/translator.type';

export const CAR_RENTAL_STEPS = (t: Translator) => [
  t('carRental.steps.information'),
  t('carRental.steps.carCategories'),
  t('common.pricingSummary'),
];
